import { S3_URL } from 'constants';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { BlockedUsersPropsInterface } from 'constants/interfaces';
import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Button, Col, Image, Row, Stack } from 'react-bootstrap';
import { useUnblockUserMutation } from 'services';

const BlockedUsers: React.FC<BlockedUsersPropsInterface> = (props) => {
	const { translate } = useTranslate();
	const { docs = [], meta = {} }: any = props.connectionData;

	const { mutateAsync: unBlockUserMutation } = useUnblockUserMutation();

	const handleUnblockUser = (id: any) => {
		unBlockUserMutation(Number(id))
			.then((res: any) => {
				if (res?.success) {
					props.refetchBlockedListData('blockedusers');
				}
			})
			.catch((err: any) => {
				console.log(err);
			});
	};
	return (
		<div>
			{meta?.totalDocs > 0 && (
				<h6 className="mb-3">
					{translate('Social.blockedUsers')}{' '}
					<span className="fw-bold">{`(${meta?.totalDocs})`}</span>
				</h6>
			)}
			<Row className="connections-row">
				{docs.length > 0 ? (
					docs?.map((res: any) => (
						<Col key={`blocked--${res?.name}-${res?.userId}}`} xxl={4} md={6}>
							<Stack className="connections-box gap-3">
								<div className="d-flex gap-3 h-100">
									<div className="connections-box-profile position-relative rounded-circle">
										<Image
											src={`${S3_URL}${res?.profilePicture}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null;
												currentTarget.src = IMAGE_PATHS.UserDefault;
											}}
											alt="logo"
											className="rounded-circle w-100 h-100"
											loading="lazy"
										/>
										<div className="connections-box-profile-overlay position-absolute top-0 left-0 w-100 h-100 d-flex align-items-center justify-content-center">
											<i className="ri-forbid-line"></i>
										</div>
									</div>
									<Stack className="gap-2 flex-1">
										<h6 className="fw-bold mb-0">{res?.name}</h6>
										<p className="mb-0">{res?.description}</p>
										<div className="d-flex gap-2 mt-auto">
											<Button
												onClick={() => handleUnblockUser(res?.userId)}
												className="gray-transparent-btn rounded-pill lh-1"
											>
												{translate('Report.unblock')}
											</Button>
										</div>
									</Stack>
								</div>
							</Stack>
						</Col>
					))
				) : (
					<Col>
						<Stack className="posted-job-box">
							<p className="mb-0">{translate('Common.noBlockedUsersFound')} </p>
						</Stack>
					</Col>
				)}
			</Row>
		</div>
	);
};

export default BlockedUsers;
